import { render, staticRenderFns } from "./ClientDetails.vue?vue&type=template&id=1945408e&scoped=true"
import script from "./ClientDetails.vue?vue&type=script&lang=js"
export * from "./ClientDetails.vue?vue&type=script&lang=js"
import style0 from "./ClientDetails.vue?vue&type=style&index=0&id=1945408e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1945408e",
  null
  
)

export default component.exports